import React from 'react';

import './style.css';

export const ERROR_TYPE = {
  UNAVAILABLE: "unavailable",
  NETWORK_ERROR: "network_error",
  NOT_AUTHORIZED: "not_authorized"
};

const MESSAGES = {
  [ERROR_TYPE.UNAVAILABLE]: "Video is unavailable at the moment",
  [ERROR_TYPE.NETWORK_ERROR]: "Video is unavailable at the moment",
  [ERROR_TYPE.NOT_AUTHORIZED]: "You are not authorized to get the book, provide correct api key"
};

export default function ErrorComponent({ type }) {
  return (
    <div className="unavailable-layer">
      <div className="unavailable-layer__text">
        <p>
          <span className="unavailable-layer__alert-icon" />
          Something went wrong
          </p>
        <p>
          {MESSAGES[type]}
        </p>
      </div>
    </div>
  );

}


// WEBPACK FOOTER //
// ./src/components/error-layer-component/ErrorLayerComponent.jsx